module.exports = __webpack_public_path__ + "img/greenvile.18692d47.jpg";